export default __webpack_public_path__ + "static/media/mp-diamante-cobalto.314e9006.svg";